import { IsDateString, IsNumber, IsOptional, IsString, ValidateNested } from 'class-validator';
import { Recoupables, RoyaltyRates, contractSubTypeList } from './DealDetails.dto';
import { Type } from 'class-transformer';
import { ContactsListItem } from '~/models/contacts.dto';

export class DealsListItemDto {
    @IsNumber()
    projectId!: number;
    @IsString()
    assetCode!: string;
    @IsOptional()
    @IsString()
    contactDisplayContract!: string | null;
    @IsOptional()
    @IsString()
    contractCompanyCode!: string | null;
    @IsOptional()
    @IsString()
    contractCompany!: string | null;
    @IsOptional()
    @IsString()
    contactNameContract!: string | null;
    @IsDateString()
    @IsOptional()
    contractDate!: string;
    @IsDateString()
    @IsOptional()
    contractStartDate!: string;
    @IsDateString()
    @IsOptional()
    contractEndDate!: string;
    @IsOptional()
    @IsString()
    accountingTerm!: string | null;
    @IsOptional()
    @IsString()
    dealType!: string | null;
    @IsOptional()
    @IsString()
    incomeType!: string | null;
    @IsNumber()
    statementDate!: number;
    @IsOptional()
    paymentNotes!: string;
    @IsOptional()
    @IsNumber()
    contractBalance!: number | null;
    @IsString()
    telephoneNumContract!: string;
    @IsString()
    emailAddressContract!: string;
    @IsOptional()
    @IsString()
    addLine1Contract!: string | null;
    @IsOptional()
    @IsString()
    addLine2Contract!: string | null;
    @IsOptional()
    @IsString()
    addLine3Contract!: string | null;
    @IsOptional()
    @IsString()
    addLine4Contract!: string | null;
    @IsString()
    websiteURLContract!: string;
    @IsNumber()
    totalRows!: number;
    @IsOptional()
    @IsString()
    contractTerm!: string | null;
    @IsString()
    contractTitle!: string;
    contractType!: string | null;
    @IsNumber()
    datesUnknown!: number;
    @IsNumber()
    contractGayaaId!: number;
    @IsString()
    firstName!: string;
    @IsString()
    lastName!: string;
    @IsNumber()
    accountingPeriod!: number;
    @IsOptional()
    @IsString()
    addressPostCode!: string | null;
    @IsNumber()
    step!: number;
    keyDates!: any;
    keyDates2!: any;

    @IsString()
    contactImage!: string;
    @Type(() => Recoupables)
    @ValidateNested()
    recoupables!: Recoupables[];
    @Type(() => RoyaltyRates)
    @ValidateNested()
    royaltyRates!: RoyaltyRates[];

    @Type(() => contractSubTypeList)
    @ValidateNested()
    contractSubTypeList!: contractSubTypeList[];
    @IsOptional()
    @IsNumber()
    companyContactId!: number | null;
    @IsOptional()
    @IsNumber()
    legalEntityId!: number | null;
    @IsOptional()
    signatureDate!: any;
    @IsOptional()
    companyContactCode!: any;
    contractContact: any;
    contractLegalContact: any;
    @IsOptional()
    contacts!: ContactsListItem[];
}

export class DealSummaryListDto {
    @IsOptional()
    @IsNumber()
    dealSongLinkFlag!: number;
    @IsNumber()
    projectId!: number;
    @IsString()
    assetCode!: string;
    @IsOptional()
    @IsString()
    contactDisplayContract!: string | null;
    @IsOptional()
    @IsString()
    contactNameContract!: string | null;
    @IsDateString()
    @IsOptional()
    contractDate!: string;
    @IsDateString()
    @IsOptional()
    contractStartDate!: string;
    @IsDateString()
    @IsOptional()
    contractEndDate!: string;
    @IsOptional()
    @IsString()
    accountingTerm!: string | null;
    @IsOptional()
    // @IsString()
    dealType!: any;
    @IsOptional()
    @IsString()
    incomeType!: string | null;
    @IsNumber()
    statementDate!: number;
    @IsOptional()
    @IsNumber()
    contractBalance!: number | null;
    @IsOptional()
    @IsString()
    telephoneNumContract!: string | null;
    @IsString()
    emailAddressContract!: string;
    @IsOptional()
    @IsString()
    addLine1Contract!: string | null;
    @IsOptional()
    @IsString()
    addLine2Contract!: string | null;
    @IsOptional()
    @IsString()
    addLine3Contract!: string | null;
    @IsOptional()
    @IsString()
    addLine4Contract!: string | null;
    @IsOptional()
    @IsString()
    websiteURLContract!: string | null;
    @IsNumber()
    totalRows!: number;
    @IsOptional()
    @IsString()
    contractTerm!: string | null;
    @IsString()
    contractTitle!: string;
    contractType!: any;
    @IsNumber()
    datesUnknown!: number;
    @IsNumber()
    contractGayaaId!: number;
    @IsString()
    firstName!: string;
    @IsString()
    lastName!: string;
    @IsNumber()
    accountingPeriod!: number;
    @IsOptional()
    @IsString()
    addressPostCode!: string | null;
    @IsNumber()
    step!: number;
    keyDates!: any;
    @IsString()
    contactImage!: string;
    @IsOptional()
    @IsNumber()
    linkedFlag!: number | null;
}
